import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'zf-feature-flags',
});

export const projectDetailSubRouteRef = createSubRouteRef({
  id: 'zf-feature-flags-project-detail',
  parent: rootRouteRef,
  path: '/default/project/:id',
});
